











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgAuthenticationSignOnUrl_saml",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "SAML",
  "abstractKey": null
};

(node ).hash = "3dca51eb139939b3be631ebf3deac281";

export default node;
